<div class="fc-login-page">

  <!-- Left art panel -->
  <div class="fc-login-art">
    <div class="fc-art-grid"></div>
    <div class="fc-login-art-brand">
      <img src="assets/images/deFault_logo_Fabricode.png" alt="Fabricode" />
    </div>
    <div class="fc-login-art-hero">
      <h2>Production monitoring,<br/>simplified.</h2>
      <p>Real-time visibility across all your machines, departments and job orders — in one unified dashboard.</p>
    </div>
    <div class="fc-login-art-foot">
      <span>Default srl · Viale Europa Unita 37, 24043 Caravaggio, Italy</span>
      <span>P.IVA 04536920160 · info@default-solutions.it</span>
      <span>&copy; Copyright 2026 Default srl</span>
    </div>
  </div>

  <!-- Right form panel -->
  <div class="fc-login-form-wrap">
    <div class="fc-login-form">

      <div class="fc-login-form-head">
        <h1>Sign in</h1>
        <p class="fc-login-sub">Enter your credentials to access Fabricode.</p>
      </div>

      <form [formGroup]="loginForm" (ngSubmit)="ngOnSubmit()" class="fc-login-fields">
        <div class="fc-field">
          <label class="fc-label" for="fc-username">Username</label>
          <input
            id="fc-username"
            class="fc-input"
            type="text"
            placeholder="Username"
            formControlName="userName"
            autocomplete="username"
            required
          />
        </div>

        <div class="fc-field">
          <label class="fc-label" for="fc-password">Password</label>
          <input
            id="fc-password"
            class="fc-input"
            type="password"
            placeholder="Password"
            formControlName="passWord"
            autocomplete="current-password"
            required
          />
        </div>

        <div class="fc-login-error" *ngIf="errorState">{{ errorMessage }}</div>

        <button
          type="submit"
          class="fc-btn fc-btn--primary fc-btn--full"
          [disabled]="!loginForm.valid"
        >
          Sign in
        </button>
      </form>
    </div>
  </div>

</div>
